// Componente Dashboard - Página principal do Dashboard
import React, { useState, useCallback } from "react";
import style from "./dashboard.module.css";
import Header from "../../components/header/header.js";
import NavBar from "../../components/nav-bar/nav-bar.js";
import BodyDashboard from "./body-dashboard.js";

/**
 * Componente Dashboard - Página principal do Dashboard
 * Gerencia o layout geral (Header, NavBar, BodyDashboard)
 * e o estado do menu lateral
 */
function Dashboard() {
  // Estado para controlar abertura/fechamento do menu lateral
  const [menuBoard, setMenuBoard] = useState(false);

  /**
   * Handler para alternar estado do menu lateral
   * @param {boolean} value - Novo estado do menu
   */
  const handleMenuBoard = useCallback((value) => {
    setMenuBoard(value);
  }, []);

  return (
    <div className="main">
      <Header menu={handleMenuBoard} />

      <div className={style["body"]}>
        {/* NavBar lateral (colapsável) */}
        <div
          className={menuBoard ? style["navbar-open"] : style["navbar-close"]}
        >
          <NavBar menu={menuBoard} navOpen={handleMenuBoard} />
        </div>

        {/* Corpo principal do Dashboard */}
        <div className={style["body-body"]}>
          <BodyDashboard />
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
